"use strict";

exports.__esModule = true;
exports.CommentWordCountTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _common = require("../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TableHead = _styledComponents["default"].thead.withConfig({
  displayName: "CommentWordCountTable__TableHead",
  componentId: "sc-10qfcna-0"
})(["display:block;"]);
var TableBody = _styledComponents["default"].tbody.withConfig({
  displayName: "CommentWordCountTable__TableBody",
  componentId: "sc-10qfcna-1"
})(["display:block;overflow-x:hidden;overflow-y:auto;"]);
var TableRow = _styledComponents["default"].tr.withConfig({
  displayName: "CommentWordCountTable__TableRow",
  componentId: "sc-10qfcna-2"
})(["display:table;width:100%;table-layout:fixed;td:last-of-type,th:last-of-type{width:50%;}"]);
var CommentWordCountTable = exports.CommentWordCountTable = /*#__PURE__*/function (_Component) {
  function CommentWordCountTable() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderRow = function (value) {
      return /*#__PURE__*/_react["default"].createElement(TableRow, {
        key: value[0]
      }, /*#__PURE__*/_react["default"].createElement("td", null, value[0]), /*#__PURE__*/_react["default"].createElement("td", null, value[1]));
    };
    return _this;
  }
  _inheritsLoose(CommentWordCountTable, _Component);
  var _proto = CommentWordCountTable.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      left = _this$props.x,
      top = _this$props.y,
      _this$props$data = _this$props.data,
      data = _this$props$data === void 0 ? {} : _this$props$data;
    var style = {
      top: top,
      left: left,
      width: width,
      height: height
    };
    var headerHeight = 50;
    var bodyHeight = height - headerHeight;
    return /*#__PURE__*/_react["default"].createElement("table", _extends({
      className: (0, _classnames["default"])(_core.Classes.HTML_TABLE, _core.Classes.HTML_TABLE_STRIPED),
      style: style
    }, (0, _common.getWidgetInteractionProps)(this.props)), /*#__PURE__*/_react["default"].createElement(TableHead, {
      style: {
        height: headerHeight
      }
    }, /*#__PURE__*/_react["default"].createElement(TableRow, null, /*#__PURE__*/_react["default"].createElement("th", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "CommentWordCountElement.header.word",
      defaultMessage: "Word"
    })), /*#__PURE__*/_react["default"].createElement("th", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "CommentWordCountElement.header.count",
      defaultMessage: "Count"
    })))), /*#__PURE__*/_react["default"].createElement(TableBody, {
      style: {
        width: width,
        height: bodyHeight
      }
    }, data.map(this.renderRow)));
  };
  return CommentWordCountTable;
}(_react.Component);
CommentWordCountTable.defaultProps = {
  device: undefined,
  devices: undefined,
  reportingPeriod: undefined
};